import PropTypes from 'prop-types';
import { Select as ChakraSelect } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';
import { ReactComponent as SelectArrowSVG } from '../../assets/form-dropdown-arrow.svg';

export default function Select({ options, onChange, selected, width, ...restProps }) {

    const onValueChange = value => {
        const optionsList = convertOptionsToObject(options);
        onChange(optionsList[value]);
    };

    const convertOptionsToObject = (array) => {
        return array.reduce((obj, item) => {
            const key = item.value ?? item.label;
            return {
                ...obj,
                [key]: item,
            };
        }, {});
    };

    return (
        <ChakraSelect
            backgroundColor={ transparentize('very-light-pink', 0.3) }
            icon={ <SelectArrowSVG /> }
            iconSize={ ['16px'] }
            width={ width }
            css={ {
                '&.chakra-select + .chakra-select__icon-wrapper': {
                    right: '16px',
                },
            } }
            value={ selected }
            onChange={ ({ target: { value } }) => onValueChange(value) }
            { ...restProps }
        >
            {
                (options && options.length) && options.map(({ value, label, disabled }) => (
                    <option
                        value={ value }
                        key={ value ?? label }
                        disabled={ disabled }
                    >
                        { label }
                    </option>
                ))
            }
        </ChakraSelect>
    );
};

Select.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        disabled: PropTypes.bool,
    })).isRequired,
    onChange: PropTypes.func,
    selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    width: PropTypes.string,
    isReadOnly: PropTypes.bool,
};

Select.defaultProps = {
    onChange: () => {},
    selected: undefined,
    width: 'fit-content',
    isReadOnly: undefined,
};
